
document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(function (mutations, obs) {
    // --- 要素の取得 ---
    const inputName = document.querySelector('input[name="properties[ペットのお名前  Pet’s Name *]"]');
    const ownerNameInput = document.querySelector('input[name="properties[飼い主のお名前  Owner’s Name]"]');
    const ownerNameField = document.querySelector('input[name="properties[飼い主のお名前  Owner’s Name]"]')?.closest('.pplr-wrapper');
    const sizeSelect = document.querySelector('[name="options[Size]"]');

    // ★ 修正点1: いきなり return せず、各処理をブロックに分けました

    // -------------------------------------------------------
    // A. サイズ選択肢がある場合の処理 (XS/Sなどの出し分け)
    // -------------------------------------------------------
    if (sizeSelect && ownerNameField) {
      const hasXS = Array.from(sizeSelect.options).some(option => option.value === 'XS');

      function toggleOwnerName() {
        const selectedValue = sizeSelect.value;
        let shouldHide = false;

        if (hasXS) {
          if (selectedValue === 'XS') shouldHide = true;
        } else {
          if (selectedValue === 'S') shouldHide = true;
        }

        if (shouldHide) {
          ownerNameInput.value = '';
          ownerNameField.style.display = 'none';
          lineBreakItems.forEach(item => {
            item.style.pointerEvents = '';
            item.style.opacity = '';
            item.style.cursor = '';
            item.removeAttribute('title');
            item.dataset.disabled = 'false';
          });
        } else {
          ownerNameField.style.display = '';
        }
      }

      // 初期実行とイベントリスナー
      toggleOwnerName();
      sizeSelect.addEventListener('change', toggleOwnerName);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  const target = document.querySelector('.product-personalizer');
  if (target) {
    observer.observe(target, { childList: true, subtree: true });
  }

  function goToLastProductImage() {
    const thumbnailButtons = document.querySelectorAll('.product-gallery__thumbnails .thumbnail');
    if (thumbnailButtons.length > 0) {
      const lastIndex = thumbnailButtons.length - 1;
      thumbnailButtons[lastIndex].click();
    }
  }
});
